module.exports = __webpack_public_path__ + "79ada3cc5f43509cdedc851b07e882cf.png";